package com.milta.feature.subscription.data.repository

import com.milta.core.appconfig.AppConfigApi
import com.milta.core.network.ApiException
import com.milta.feature.subscription.domain.entity.SubscriptionAccessCheck
import com.milta.feature.subscription.domain.repository.SubscriptionAccessRepository

private const val SUBSCRIPTION_EXPIRED_ERROR = "error.subscription_expired"

/**
 * GET /app-config: authenticated, any role, tiny body, and not `[SubscriptionExempt]` on the backend,
 * so it goes through the subscription check. Called on the API directly, never through
 * AppConfigRepository's in-memory cache. A 403 also re-emits SessionEvent.SubscriptionExpired
 * (MiltaApiClient), which carries the up-to-date scope to the blocking screen.
 */
class SubscriptionAccessRepositoryImpl(private val api: AppConfigApi) : SubscriptionAccessRepository {
    override suspend fun checkAccess(): SubscriptionAccessCheck = runCatching { api.getAppConfig() }.fold(
        onSuccess = { SubscriptionAccessCheck.Granted },
        onFailure = { e ->
            when {
                e is ApiException && e.statusCode == 403 && e.message == SUBSCRIPTION_EXPIRED_ERROR -> SubscriptionAccessCheck.Denied
                e is ApiException -> SubscriptionAccessCheck.Failed
                else -> SubscriptionAccessCheck.Offline
            }
        },
    )
}
